import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { posActions } from '../../../reducers/pos.reducer';
import Button from '../../common/Button.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
var PageDelete = function PageDelete(_ref) {
  var pagesAction = _ref.pagesAction;
  var _useParams = useParams(),
    pageID = _useParams.pageID;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Delete Page"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      pagesAction({
        formData: {
          pageID: pageID
        },
        method: 'delete'
      });
    },
    style: {
      width: 120
    },
    requireConfirmation: true,
    type: "close",
    permission: "edit-pos-sections"
  }))));
};
var mdtp = {
  pagesAction: posActions.pages
};
export default connect(null, mdtp)(PageDelete);